import React from 'react'
import { RequestItemModel } from '../requestsModel'
import { makeStyles } from '@material-ui/core/styles'
import { FormattedMessage } from 'react-intl'
import styles from '../../../styles'
import Link from '../../../components/link/Link'
import RequestCard from './RequestCard'
import RequestCardEmpty from './RequestCardEmpty'
import Header from '../header/Header'

const useStyle = makeStyles(
    (theme) => (
        {
            ...styles(theme),
            linkStyle: {
                marginTop: 18,
                float: 'right'
            },
            treatedList: {
                marginTop: 44
            },
            marginBottomLink: {
                marginBottom: 25
            }
        }
    )
)

interface AcceptingProps {
    requests: RequestItemModel[],
    fetchRequestsList: () => void
}

type ListProps = AcceptingProps

const RequestList: React.FC<ListProps> = (
    {
        requests,
        fetchRequestsList
    }
) => {
    const [seeRequestsTreated, setSeeRequestsTreated] = React.useState<boolean>(false)
    const classes = useStyle()

    // Tri des demandes par statut cloturé
    const requestsInProgress = requests.filter((item: RequestItemModel) => !item.cloture && !item.annule)
    const requestsTreated = requests.filter((item: RequestItemModel) => item.cloture || item.annule)

    return (
        <>
            <Header requestsLength={requests.length} fetchRequestsList={fetchRequestsList} />
            {
                requestsInProgress.length === 0 ?
                    <div><RequestCardEmpty /></div>
                    :
                    requestsInProgress.map((item: RequestItemModel) => <div key={item.id} className="col-xs-12"><RequestCard request={item} /></div>)
            }
            {seeRequestsTreated && <div className={classes.treatedList}>
				<Header requestsLength={requestsTreated.length} treatedRequestsList />
                {requestsTreated.map((item: RequestItemModel) => <div key={item.id}><RequestCard request={item} /></div>)}
			</div>}

            {<div className={classes.linkStyle}>
				<Link
					color="colorAccessibility"
					textStyle="text21"
					className={classes.marginBottomLink}
					onClick={() => setSeeRequestsTreated(true)}
				>
					<FormattedMessage
						id="requests.link"
						defaultMessage="Afficher vos demandes clôturées"
						description="Request link"
					/>
				</Link>
			</div>}
        </>
    )
}

export default RequestList
